export default __webpack_public_path__ + "static/media/square.8c2fd5ee.svg";